import Container from 'react-bootstrap/Container';
import { useParams } from 'react-router-dom';
import InventoryList from '../modules/ListInventory';

interface ApplicationProps {
    updatefunc: () => void;
}

function InventoryByCategoryPage({updatefunc}: ApplicationProps){
    
    const { category } = useParams();
    

    return (
        <> 
            <Container>
                <InventoryList category_limit={category ? category : "featured"} updatefunc={updatefunc} />           
            </Container>
        </>
    )
}

export default InventoryByCategoryPage;